import { Suspense, useEffect } from 'react'
import { createRoute, Navigate, Outlet } from '@tanstack/react-router'
import { rootRoute } from './__root'
import { useSession } from '@/lib/auth'
import { TooltipProvider } from '@/components/ui/tooltip'
import { TopBar } from '@/components/top-bar'
import { NowPlayingBar } from '@/components/now-playing-bar'
import { FullPageLoader } from '@/components/loading-spinner'
import { PlaybackProvider, usePlayback } from '@/lib/playback-context'
import { connectSSE } from '@/lib/sse'

export const authLayoutRoute = createRoute({
	getParentRoute: () => rootRoute,
	id: '_auth',
	component: AuthLayout,
})

function AuthLayout() {
	const { data: session, isPending } = useSession()

	useEffect(() => {
		if (!session) return
		return connectSSE()
	}, [session])

	if (isPending) {
		return <FullPageLoader />
	}

	if (!session) {
		return <Navigate to="/sign-in" />
	}

	return (
		<TooltipProvider delayDuration={0}>
			<PlaybackProvider>
				<Suspense fallback={<FullPageLoader />}>
					<AuthLayoutInner />
				</Suspense>
			</PlaybackProvider>
		</TooltipProvider>
	)
}

function AuthLayoutInner() {
	const { isPlaying } = usePlayback()

	return (
		<div className="flex min-h-screen flex-col" style={{ paddingBottom: isPlaying ? 64 : 0 }}>
			<TopBar />
			<Outlet />
			<NowPlayingBar />
		</div>
	)
}
